import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const editProfileDataReducer = (
  state = initialState.editProfileData,
  action
) => {
  switch (action.type) {
    case types.FETCH_SECURITY_QUESTIONS_STARTED:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case types.FETCH_SECURITY_QUESTIONS_SUCCEEDED:
      return {
        ...state,
        securityQuestions: action.payload,
        isLoading: false,
        error: null
      };
    case types.FETCH_SECURITY_QUESTIONS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default editProfileDataReducer;
